import { environment } from '../../environments/environment.prod';

export const CONSTANTS = Object.freeze({
    defaultLocale: 'en',
    userApiRoot: `${environment.userApi}/${environment.userApiVersion}/`
});
